import { SvgIcon, SvgIconProps } from '@mui/material'

export const LocalIcon = {
  Check: (props: SvgIconProps) => {
    return (
      <SvgIcon
        viewBox="0 0 64 64"
        {...props}
        sx={{
          animation: 'checkAnimation 0.6s ease-out',
          '@keyframes checkAnimation': {
            '0%': {
              transform: 'scale(0)',
              opacity: 0,
            },
            '50%': {
              transform: 'scale(1.1)',
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
          },
          '& path:last-of-type': {
            animation: 'checkmarkAnimation 0.4s ease-out 0.2s both',
          },
          '@keyframes checkmarkAnimation': {
            '0%': {
              strokeDashoffset: 100,
              strokeDasharray: 100,
              opacity: 0,
            },
            '100%': {
              strokeDashoffset: 0,
              strokeDasharray: 100,
              opacity: 1,
            },
          },
          ...props.sx,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
          <path
            d="M31.9993 3.6669C16.3763 3.6669 3.66602 16.3772 3.66602 32.0002C3.66602 47.6233 16.3763 60.3336 31.9993 60.3336C47.6224 60.3336 60.3327 47.6233 60.3327 32.0002C60.3327 16.3772 47.6224 3.6669 31.9993 3.6669ZM31.9993 57.0002C18.2142 57.0002 6.99935 45.7854 6.99935 32.0002C6.99935 18.2151 18.2142 7.00023 31.9993 7.00023C45.7845 7.00023 56.9993 18.2151 56.9993 32.0002C56.9993 45.7854 45.7845 57.0002 31.9993 57.0002Z"
            fill="currentColor"
          />
          <path
            d="M44.9291 22.8796L30.224 37.5844L22.6791 30.04C22.0287 29.389 20.9727 29.389 20.3223 30.04C19.6712 30.6908 19.6712 31.7461 20.3223 32.3968L29.0456 41.1198C29.3708 41.4454 29.7976 41.6081 30.224 41.6081C30.6505 41.6081 31.0772 41.4454 31.4024 41.1198L47.2858 25.2364C47.9369 24.5856 47.9369 23.5303 47.2858 22.8796C46.6354 22.2286 45.5794 22.2286 44.9291 22.8796Z"
            fill="currentColor"
          />
        </svg>
      </SvgIcon>
    )
  },
}
